const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
};

export const getFbp = () => getCookie('_fbp');

export const getFbc = () => {
    const fbc = getCookie('_fbc');
    if (fbc) return fbc;
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    return fbclid ? `fb.1.${Date.now()}.${fbclid}` : null;
};

export const getMetaTracking = () => ({
    fbc: getFbc(),
    fbp: getFbp(),
    event_source_url: window.location.href,
    user_agent: navigator.userAgent,
});
